import type { IconNode } from "lucide-react";

/**
 * The Autopilot's mark: a steering wheel in lucide's own line style (lucide has none): the
 * ring is the 2-unit stroke every icon of the panel has, a small hub, two spokes that droop to
 * it and one down to the ring, all 2 units, so the glyph weighs what Bell and BookOpen weigh.
 * The static icon and its animated twin (`steering-wheel-twin.tsx`) read the same node.
 */
export const STEERING_WHEEL: IconNode = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "ring" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "hub" }],
  ["path", { d: "M2.3 10.8 9.9 12.2", key: "left" }],
  ["path", { d: "M21.7 10.8 14.1 12.2", key: "right" }],
  ["path", { d: "M12 14v8", key: "bottom" }],
];
